import * as tslib_1 from "tslib";
// Core packages
import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
// Third party packages
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AlignmentType, Document, HeadingLevel, Media, Packer, PageOrientation, Paragraph, Table, TableCell, TableRow, TextRun } from "docx";
import * as FileSaver from "file-saver";
import moment from "moment";
import { CookieService } from 'ngx-cookie-service';
// Custom packages
import { DocumentArchivesService } from "src/app/modules/properties/document-archives.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { Property } from "src/app/shared/models/property/property.model";
import { ConfigService } from 'src/app/shared/services/config.service';
import { HelperService } from "src/app/shared/services/helper.service";
import DocumentTypeStructure from "../../documentTypes";
var ExportContractsDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ExportContractsDialogComponent(dialogRef, data, configService, cookieService, translateService, propertiesService, helperService, documentArchivesService, settingsService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.configService = configService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.propertiesService = propertiesService;
        this.helperService = helperService;
        this.documentArchivesService = documentArchivesService;
        this.settingsService = settingsService;
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.subscriptions = [];
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.send'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-paper-plane',
                inline: true,
            },
        };
        // END - Add communication form
        this.dialogIsLoading = true;
        this.property = new Property();
        this.propertyName = "";
        this.subscriptionType = "FULL";
        this.documentTypeStructure = new DocumentTypeStructure();
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.documentArchive = [];
    }
    /**
     * Init component
     *
     */
    ExportContractsDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get current lang
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        var host = "" + this.configService.frontEndHost;
        this.subscriptions.push(this.propertiesService.get(this.data.propertyId).subscribe(function (res) {
            if (res.status) {
                _this.property.setData(res.data);
                _this.propertyData = res.data;
                _this.propertyName = res.data.name;
                if (_this.propertyData &&
                    _this.propertyData.subscription &&
                    _this.propertyData.subscription.key) {
                    _this.subscriptionType = _this.propertyData.subscription.key;
                    if (_this.propertyData.documentArchive) {
                        _this.documentArchiveId = _this.propertyData.documentArchive;
                    }
                }
                // If property has a structure ID, than retrive related data
                // and document archive
                if (_this.propertyData.structure) {
                    _this.subscriptions.push(_this.settingsService.getDocument().subscribe(function (res) {
                        if (res.status) {
                            if (res.data &&
                                Array.isArray(res.data) &&
                                res.data.length > 0 &&
                                res.data[0].area &&
                                Array.isArray(res.data[0].area)) {
                                _this.documentTemplateId = res.data[0]._id;
                                _this.documentTemplate = res.data[0].area;
                            }
                            _this.documentArchivesService
                                .getContracts(_this.property.get("documentArchive"))
                                .subscribe(function (res) {
                                var e_1, _a;
                                if (res.status &&
                                    res.data &&
                                    Array.isArray(res.data)) {
                                    try {
                                        for (var _b = tslib_1.__values(res.data.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                                            var _d = tslib_1.__read(_c.value, 2), i = _d[0], element = _d[1];
                                            element.index = i;
                                            var documentKey = element.key;
                                            var section = _this.documentTypeStructure.getDocRoute2(documentKey, _this.documentTemplate);
                                            var documentId = 'generic';
                                            if (element.structureObjectId !== '' &&
                                                element.structureObjectId !== '-1') {
                                                documentId = element.docId;
                                            }
                                            var subDocumentId = element.subDocId;
                                            element.qrcode =
                                                host + "/qrcode/" + _this.documentArchiveId + "/" + section + "/" + documentId + "/" + documentKey + "/" + subDocumentId;
                                            if (!element.deleted && !element.expired) {
                                                _this.documentArchive.push(element);
                                            }
                                        }
                                    }
                                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                    finally {
                                        try {
                                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                        }
                                        finally { if (e_1) throw e_1.error; }
                                    }
                                    _this.dialogIsLoading = false;
                                }
                                else {
                                    _this.dialogIsLoading = false;
                                }
                            });
                        }
                        else {
                            _this.dialogIsLoading = false;
                        }
                    }, function (err) {
                        _this.helperService.handleError(err);
                        _this.dialogIsLoading = false;
                    }));
                }
                else {
                    _this.dialogIsLoading = false;
                }
            }
        }, function (err) {
            _this.dialogIsLoading = false;
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Export word file
     *
     * @since 1.0.0
     */
    ExportContractsDialogComponent.prototype.onExportFile = function () {
        var e_2, _a;
        var _this = this;
        // Create document data
        var doc = new Document();
        var rows = [];
        rows.push(new TableRow({
            tableHeader: true,
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            text: this.translateService.instant('properties.documentsPage.docType').toUpperCase(),
                            heading: HeadingLevel.HEADING_2,
                            alignment: AlignmentType.CENTER,
                        }),
                    ],
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            text: this.translateService.instant('properties.structures.structure').toUpperCase(),
                            heading: HeadingLevel.HEADING_2,
                            alignment: AlignmentType.CENTER,
                        }),
                    ],
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            text: this.translateService.instant('properties.documentsPage.supplier').toUpperCase(),
                            heading: HeadingLevel.HEADING_2,
                            alignment: AlignmentType.CENTER,
                        }),
                    ],
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            text: this.translateService.instant('properties.documentsPage.date').toUpperCase(),
                            heading: HeadingLevel.HEADING_2,
                            alignment: AlignmentType.CENTER,
                        }),
                    ],
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            text: this.translateService.instant('properties.documentsPage.expiredDate').toUpperCase(),
                            heading: HeadingLevel.HEADING_2,
                            alignment: AlignmentType.CENTER,
                        }),
                    ],
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            text: this.translateService.instant('common.cta.printQr').toUpperCase(),
                            heading: HeadingLevel.HEADING_2,
                            alignment: AlignmentType.CENTER,
                        }),
                    ],
                }),
            ],
        }));
        try {
            for (var _b = tslib_1.__values(this.documentArchive), _c = _b.next(); !_c.done; _c = _b.next()) {
                var element = _c.value;
                var qrImage = document
                    .getElementById("qr-img-" + element.index)
                    .lastElementChild.lastElementChild.getAttribute("src");
                var image = Media.addImage(doc, qrImage, 105, 105, {});
                var row = new TableRow({
                    children: [
                        new TableCell({
                            margins: {
                                top: 60,
                                left: 60,
                                bottom: 60,
                                right: 60,
                            },
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: element.type,
                                            size: 26,
                                        })
                                    ]
                                }),
                            ],
                        }),
                        new TableCell({
                            margins: {
                                top: 60,
                                left: 60,
                                bottom: 60,
                                right: 60,
                            },
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: element.structureObjectName,
                                            size: 26,
                                        })
                                    ]
                                }),
                            ],
                        }),
                        new TableCell({
                            margins: {
                                top: 60,
                                left: 60,
                                bottom: 60,
                                right: 60,
                            },
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: element.data.ragioneSocialeFornitore,
                                            size: 26,
                                        })
                                    ]
                                }),
                            ],
                        }),
                        new TableCell({
                            margins: {
                                top: 60,
                                left: 60,
                                bottom: 60,
                                right: 60,
                            },
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: moment(element.data.dataDocumento).isValid() ?
                                                moment(element.data.dataDocumento).format("L") :
                                                element.data.dataDocumento,
                                            size: 26,
                                        })
                                    ]
                                }),
                            ],
                        }),
                        new TableCell({
                            margins: {
                                top: 60,
                                left: 60,
                                bottom: 60,
                                right: 60,
                            },
                            children: [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: moment(element.dateExpired).isValid() ?
                                                moment(element.dateExpired).format("L") :
                                                element.dateExpired,
                                            size: 26,
                                        })
                                    ]
                                }),
                            ],
                        }),
                        new TableCell({
                            margins: {
                                top: 60,
                                left: 60,
                                bottom: 60,
                                right: 60,
                            },
                            children: [
                                new Paragraph({
                                    children: [
                                        image
                                    ],
                                }),
                            ],
                        }),
                    ],
                });
                rows.push(row);
                var blankRow = new TableRow({
                    children: [
                        new TableCell({
                            children: [
                                new Paragraph({
                                    text: '',
                                }),
                            ],
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    text: '',
                                }),
                            ],
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    text: '',
                                }),
                            ],
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    text: '',
                                }),
                            ],
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    text: '',
                                }),
                            ],
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    text: '',
                                }),
                            ],
                        }),
                    ],
                });
                rows.push(blankRow);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        doc.addSection({
            properties: {
                orientation: PageOrientation.LANDSCAPE,
            },
            children: [
                new Paragraph({
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_1,
                    spacing: { after: 400 },
                    children: [
                        new TextRun({
                            text: "CONDOMINIO " + this.property.get("name"),
                            bold: true,
                            allCaps: true,
                            color: "auto",
                            size: 24 * 2,
                        }),
                    ],
                }),
                // new Paragraph(image),
                new Table({
                    rows: rows,
                }),
            ],
        });
        // Used to export the file into a .docx file
        Packer.toBlob(doc).then(function (blob) {
            FileSaver.saveAs(blob, "Contratti_" + _this.property.get("name") + ".docx");
        });
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     *
     */
    ExportContractsDialogComponent.prototype.onClose = function () {
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.dialogRef.close();
    };
    return ExportContractsDialogComponent;
}());
export { ExportContractsDialogComponent };
